import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';

export class DeleteCommentTopicAnnotationAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(token, orderId, attachmentId, versionId, commentId, next, complete, error) {
    const httpConfig = {
      url: `/g/guest/order/${orderId}/attachment/${attachmentId}/version/${versionId}/comment/${commentId}`,
      method: 'delete',
      headers: {
        'accept': 'application/json',
        'Content-Type': `application/json`,
        'Authorization': `Bearer ${token}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig, false);
    });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}